var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGirl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.76 92.06",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Girl_svg__cls-1{fill:#878789}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Girl_svg__cls-1",
    d: "M17 92.06c-2.49-.86-3.24-2.76-3.22-5.21V69.59H9.64C7 69.58 6 68.43 6.43 65.84 7 62.25 7.7 58.66 8.34 55.08a.78.78 0 00-.05-.51l-.64 1.24C6.53 58 4.39 58.88 2.35 58a4 4 0 01-2-5.46c2.5-5.87 5-11.72 7.54-17.57q1.23-2.84 2.44-5.67a5 5 0 015.08-3.37c5.3.1 10.61.11 15.91 0a3.91 3.91 0 014.16 2.76c3.32 8.19 6.69 16.36 10 24.53a3 3 0 00.2.34v1.62a2.42 2.42 0 00-.18.36 3.82 3.82 0 01-3.53 2.87c-1.74.12-2.69-1-3.4-2.41-.26-.53-.55-1-.82-1.58a.69.69 0 00-.09.54c.6 3.76 1.22 7.52 1.81 11.29a2.69 2.69 0 01-2.8 3.35c-1.28 0-2.57.07-3.85 0-1-.07-1.22.32-1.22 1.26.05 5.3 0 10.6 0 15.9 0 2.48-.66 4.44-3.2 5.33h-1.7c-2.52-.82-3.3-2.68-3.27-5.16.06-5.37 0-10.75 0-16.12v-1.1H22V86.9c0 2.47-.74 4.35-3.25 5.18zM24.06 0a31.24 31.24 0 013.62 1.18A11.49 11.49 0 0122.27 23 11.5 11.5 0 0120.86.19a3.69 3.69 0 00.56-.19z"
  })))));
}

export default SvgGirl;